import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Message from 'components/text/Message/Message'

import HeaderSubNavItemSubLink from '../../HeaderSubNavItemSubLink/HeaderSubNavItemSubLink'

import s from './Nav.scss'


class HeaderSubNavDropdownNav extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
  }

  render() {
    const { className, items, state, setState, _ref } = this.props

    return (
      <div className={cx(s.root, className)}>
        {
          items.map(({ title, to, lg, toBottom, dataTestId, spaceBefore, onClick, adaIndex }, index) => (
            <div
              key={index}
              className={cx(s.item, { [s.itemToBottom]: toBottom, [s.itemSpaceBefore]: spaceBefore })}
            >
              {
                to ? (
                  <HeaderSubNavItemSubLink
                    className={cx(s.link, { [s.linkLg]: lg })}
                    title={title}
                    index={adaIndex}
                    to={to}
                    dataTestId={dataTestId}
                    onClick={onClick}
                    {...{ state, setState, _ref }}
                  />
                ) : (
                  <Message
                    tag="div"
                    text={title}
                    className={s.text}
                  />
                )
              }
            </div>
          ))
        }
      </div>
    )
  }
}


export default HeaderSubNavDropdownNav
